import { css } from "styled-components";

/**
 * Copy imported from the PIM carries inline Arial/Inter and pt sizes on every span. These rules force it back to the
 * site's body typography (Montserrat 15px/500) regardless of what the inline styles say.
 */
const siteBodyTypography = css`
    font-family: "Montserrat", sans-serif;
    font-size: 15px;
    font-weight: 500;
    line-height: 1.5;
    * {
        font-family: inherit !important;
        font-size: inherit !important;
    }
`;

/** Category (L2) copy: site body typography, bold left as authored. */
export const categoryCopyCss = css`
    ${siteBodyTypography}
`;

/**
 * Product list (L3) and product detail (L4) copy: site body typography with all bold removed except the descriptor
 * that opens each bullet point (e.g. "<li><strong>Rock-Solid Construction</strong>: ...</li>").
 */
export const productCopyCss = css`
    ${siteBodyTypography}
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    strong,
    b {
        font-weight: inherit;
    }
    li > strong:first-child,
    li > b:first-child {
        font-weight: 700;
    }
`;

/** Product FAQ tab: site body typography with the questions (headings or bold text) in bold. */
export const productFaqCopyCss = css`
    ${siteBodyTypography}
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-weight: 700;
        line-height: 1.5;
        margin: 15px 0 5px;
    }
    strong,
    b {
        font-weight: 700;
    }
    p {
        margin-bottom: 10px;
    }
`;
